import { PopoverMenuUniDriver } from '@wix/design-system/dist/testkit/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DisabledTooltipButtonUniDriver } from '../DisabledTooltip/DisabledTooltipButton.uni.driver';

export function CustomFieldPopoverUniDriver(base: UniDriver, body: UniDriver) {
  const customFieldPopoverDriverBase = () =>
    base.$('[data-hook="custom-field-options"]');

  const customFieldPopoverDriver = () =>
    PopoverMenuUniDriver(customFieldPopoverDriverBase(), body);

  const customFieldOptionsTrigger = () =>
    DisabledTooltipButtonUniDriver(base, body, {
      dataHook: 'custom-field-options-trigger',
    });

  const getCustomFieldOptionsAt = () => {
    return {
      open: () =>
        customFieldPopoverDriver()
          .getTriggerElement('custom-field-options-trigger')
          .click(),
      clickEdit: () =>
        customFieldPopoverDriver().clickAtChildByDataHook(
          'custom-field-options-edit',
        ),
      clickArchive: () =>
        customFieldPopoverDriver().clickAtChildByDataHook(
          'custom-field-options-archive',
        ),
    };
  };

  return {
    exists: () => customFieldPopoverDriverBase().exists(),
    isDisabled: () => customFieldOptionsTrigger().isButtonDisabled(),
    getTooltipText: () => customFieldOptionsTrigger().getTooltipText(),
    getCustomFieldOptionsAt,
  };
}
